import React, { useRef, useEffect, useState } from "react";
 
interface ChartDropdownProps {
  assignedId: string;
  selectedChart: string;
  onSelectChart: (chartType: string) => void;
}
 
const ChartDropdown: React.FC<ChartDropdownProps> = ({
  onSelectChart,
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef<HTMLDivElement | null>(null);
 
  const handleDropdownClick = () => {
    setIsOpen((prev) => !prev);
  };
 
  const handleChartSelection = (chartType: string) => {
    onSelectChart(chartType);
    setIsOpen(false);
  };
 
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target as Node)) {
        setIsOpen(false);
      }
    };
 
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);
 
  return (
    <div className="dropdown-section" ref={dropdownRef}>
      <button className="typeOptionButton" onClick={handleDropdownClick}>
        <img src={"svg/barchartwhite.svg"} width="13" height="13" />
      </button>
      {isOpen && (
        <div className="selectChartType">
          <ul>
            <h2>Show me:</h2>
            <li onClick={() => handleChartSelection("bar")}>Bar Chart</li>
            <li onClick={() => handleChartSelection("loan")}>Loan Composition</li>
          </ul>
        </div>
      )}
    </div>
  );
};
 
export default ChartDropdown;